import { Components, Theme } from '@mui/material';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        padding: '8px 16px',
        fontWeight: 600,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
      },
      containedPrimary: {
        background: 'linear-gradient(135deg, #2A51F7 0%, #4F46E5 100%)',
        boxShadow: '0 4px 14px rgba(42, 81, 247, 0.4)',
        '&:hover': {
          background: 'linear-gradient(135deg, #4466FF 0%, #6366F1 100%)',
          boxShadow: '0 6px 20px rgba(42, 81, 247, 0.6)',
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 12,
        backgroundImage: 'none', // Remove o overlay padrão de cor do MUI no modo dark
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
      }),
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: 'none',
        borderBottom: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
      }),
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        borderRight: `1px solid ${theme.palette.divider}`,
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: '12px 16px',
        color: theme.palette.text.primary,
      }),
      head: ({ theme }) => ({
        fontWeight: 600,
        backgroundColor: theme.palette.mode === 'dark' ? '#0F172A' : '#F1F5F9',
        color: theme.palette.text.secondary,
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 4,
        height: 6,
        backgroundColor: theme.palette.mode === 'dark' ? '#1E293B' : '#E2E8F0',
      }),
      bar: {
        borderRadius: 4,
        background: 'linear-gradient(90deg, #2A51F7 0%, #10B981 100%)',
      },
    },
  },
};
